module.exports = __webpack_public_path__ + "static/media/mreavesxlsannaru-020415006EmigreWebOnly.52c5caaf.woff2";